import Component from 'vue-class-component';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required, maxLength , helpers, not} from 'vuelidate/lib/validators';
import { Prop , Mixins} from 'vue-property-decorator';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import {COURSE_EVENTS} from '@/content/values/events';
import { STORE } from '@/core/store/core.store';
import CourseActions from '@/content/actions/course.actions';
import Course from '@/content/models/course.model';

@Component({})
export default class EdSectionMaterialCreator extends Mixins(CourseToolsMixin) {

  /* Props */
  @Prop() readonly courseId: number;
  @Prop({default: null}) readonly classId: number;

  /* Data */
  public form: any = {}

  /* Computed */
  get header(): string {
    if(this.editionMode) {
      this.init(this.section.sectionName);
      return `${this.$i18n.t('lesson.editTitle')}: ${this.section.sectionName}`; 
    } else {
      this.init();
      return this.section.sectionId ?  `${this.$i18n.t('lesson.addTitleTo')} ${this.section.sectionName}` : `${this.$i18n.t('lesson.addTitle')}`;
    }
  }

  get course(): Course {
    return this.getCourseFromStore({courseId: this.courseId , classId: this.classId});
  }

  get section(): any {
    return this.course.component.section;
  }

  get editionMode(): boolean {
    return this.course.component.edition;
  }

  get nameFieldValidation(): boolean {
    return this.form.get('name').value === this.section.sectionName;
  }

  /* Methods */
  private init(name = '') {
    this.form = EdFormModel([
      EdInputModel('name', name, {
        required,
        maxLength: maxLength(60)
      },
        name ? true : false
      ),
    ]);
  }

  public cancel() {
    this.init();
  }

  public createOrUpdateSection() {
    (this.$parent.$refs.EdLoading as any).show(this.$i18n.t('common.saving'));
    if(!this.editionMode) {
      this.$Courses.Store.createCourseMaterialSectionA({
        name: this.form.get('name').value,
        parentId: this.section.sectionId ? this.section.sectionId : null,
        courseId: this.courseId,
        classId: this.classId,
      })
      .then(() => {
        this.init();
        (this.$parent.$refs.EdLoading as any).hide();
      });
    } else {
      this.$Courses.Store.updateCourseMaterialSectionA({
        name: this.form.get('name').value,
        materialSectionId: this.section.sectionId,
        courseId: this.courseId,
        classId: this.classId
      })
      .then(() => {
        this.$edEventBus.$emit(COURSE_EVENTS.REFRESH_COURSE_MATERIALS);
        this.init();
        (this.$parent.$refs.EdLoading as any).hide();
       });
    }
  }

  /* Hooks */

  created() {
    if(this.editionMode) {
      this.init(this.section.sectionName);
    } else {
      this.init();
    }    
  }
}